// TODO (UI-3452): delete this entire component when FF is removed
import * as _ from 'lodash';
import * as React from 'react';
import { utils } from '@blend/ui-common';
import * as deploymentConfig from 'login-utils/deploymentConfig';

const { featureFlags } = utils;

interface TermsOfServicePixelTrackerState {
  trackerUrls: string[];
}

export default class TermsOfServicePixelTracker extends React.Component<{}, TermsOfServicePixelTrackerState> {
  constructor(props) {
    super(props);

    const firePixels = !!deploymentConfig.get().enableCustomPixelTracker;
    const nonce = Math.floor(Math.random() * 1e20);
    // for this set of tracking pixels, the feature flag will also cause the non-google pixels to fire in GS instead
    // see intertstitial.js for more info near the call to fireGoogleTagManagerGettingStartedEvent()
    // TODO (UI-3452): delete this entire component when FF is removed
    const trackerUrls = featureFlags.isEnabled('removeSubsetOfCustomTrackingPixels20190107')
      ? []
      : [
          `https://ad.doubleclick.net/ddm/activity/src=2549153;type=mtgxt0;cat=mtg_b0;u1=;u2=;u3=;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=${nonce}?`,
          'https://www.facebook.com/tr?id=1578146899100389&ev=MTG_Blend_GettingStarted&noscript=1',
          'https://googleads.g.doubleclick.net/pagead/viewthroughconversion/984436569/?guid=ON&script=0',
          'https://sp.analytics.yahoo.com/spp.pl?a=10000&.yp=10028472&ec=appstart',
          'https://wellsfargobankna.demdex.net/event?c_pagetype=Blend_GettingStarted&c_product_code=mtg',
        ];

    this.state = { trackerUrls: firePixels ? trackerUrls : [] };
  }

  shouldComponentUpdate() {
    /* istanbul ignore next: (UI-5482) */
    return false;
  }

  render() {
    const { trackerUrls } = this.state;
    return (
      <div style={{ display: 'none' }}>
        {_.map(trackerUrls, url => (
          <img key={url} height="0" width="0" alt="" style={{ display: 'none' }} src={url} />
        ))}
      </div>
    );
  }
}
